import { Fragment } from 'react';
import { filesCopyIcons } from '../../../components/common/Icons';

const copyIcon = filesCopyIcons('shimmer select-none text-opacity-0');

const VisitsShimmer: React.FC = () => {
    return (
        <Fragment>
            <div className="space-y-5">
                <div className="p-5 h-52 flex justify-between items-center text-13 font-700 w-full">
                    <p className="text-neutral-black shimmer select-none text-opacity-0 w-full">
                        Jun 30, 2022: Acute gastritis
                    </p>
                </div>
                <div className="p-5 flex space-x-8 font-400">
                    <p className="w-24 h-24 flex justify-center items-center text-12 font-700 bg-darwin-accent-symptoms-blue-200 text-darwin-accent-symptoms-blue-800 rounded-full  shimmer select-none text-opacity-0">
                        Sx
                    </p>
                    <div className="flex-1 space-y-9">
                        <p className="text-darwin-neutral-900 text-13  shimmer select-none text-opacity-0">
                            Fever | Cold | Painful Swallowing
                        </p>
                    </div>
                </div>
                <div className="p-5 flex space-x-8 font-400">
                    <p className="w-24 h-24 flex justify-center items-center text-12 font-700 bg-darwin-accent-investigations-ochre-200 text-darwin-accent-investigations-ochre-800 rounded-full  shimmer select-none text-opacity-0">
                        Lab
                    </p>
                    <div className="flex-1 space-y-9">
                        <p className="text-darwin-neutral-900 text-13  shimmer select-none text-opacity-0">
                            CBC | LFT | KFT
                        </p>
                    </div>
                </div>
                <div className="p-5 flex space-x-8 font-400">
                    <p className="w-24 h-24 flex justify-center items-center text-12 font-700 bg-darwin-accent-medicines-pink-200 text-darwin-accent-medicines-pink-800 rounded-full  shimmer select-none text-opacity-0">
                        Mx
                    </p>
                    <div className="flex-1 space-y-9  shimmer select-none text-opacity-0">
                        <div>
                            <div className="">
                                {/* <p className="uppercase font-700 shimmer select-none text-opacity-0">
                                    seagel susp
                                </p> */}
                                <p className="flex justify-center items-center text-12 font-700 bg-darwin-accent-medicines-pink-200 text-darwin-accent-medicines-pink-800 rounded-full  shimmer select-none text-opacity-0">
                                    (Flucanazole)
                                </p>
                            </div>
                            <p className="text-darwin-neutral-700 text-13  shimmer select-none text-opacity-0">
                                1 tablet | 1-0-1 | Before meal | 7d
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default VisitsShimmer;
